import { ImageProcessingState } from "@nova/constants"
import { VideoJob } from "@nova/protobuf"
import { createSelector } from "@reduxjs/toolkit"
import { selectVideoFlightById } from "features/entity-caching/flights/selectors"
import { RootState } from "integrations/redux"
import { get, memoize } from "nodash"
import { selectUploadsForSet, VideoState } from "plugins/Video/FMV/VideoSlice"

export const selectVideoUploads = memoize((id: string) =>
    createSelector([selectVideoFlightById(id), selectUploadsForSet(id)], (flight, uploads) => {
        if (!id || !flight) return
        if (flight.job) {
            const files: VideoState[] = [
                {
                    id: "mock-video-file-id",
                    name: flight.job.videoPath.split("/").at(-1) || "video.mp4",
                    state: ImageProcessingState.UploadDone,
                    takenAt: flight.job.createdAt,
                },
            ]
            if (flight.job.srtPath) {
                files.push({
                    id: "metadata-file-id",
                    name: flight.job.srtPath.split("/").at(-1) || "metadata.srt",
                    state: ImageProcessingState.UploadDone,
                    takenAt: flight.job.createdAt,
                    isSRT: true,
                })
            }
            return files
        } else return uploads
    })
)

export const selectVideoJobs = (s: RootState) =>
    s.project.data.videoFlights.reduce(
        (acc, cur) => {
            if (cur.job) {
                acc[cur.id] = cur.job
            }
            return acc
        },
        {} as Record<string, VideoJob>
    )

export const selectVideoUploadSize = memoize((id: string) =>
    createSelector([selectVideoUploads(id)], (uploads) => {
        let totalSize = 0
        uploads?.forEach((upload) => {
            const size = get(upload, "size", 0)
            totalSize += size
        })
        return totalSize
    })
)

export const selectVideoFinishedUploadSize = memoize((id: string) =>
    createSelector([selectVideoUploads(id)], (uploads) => {
        let totalSize = 0
        uploads?.forEach((upload) => {
            const state = get(upload, "state")
            const size = get(upload, "size", 0)
            if (state !== ImageProcessingState.UploadDone) return
            totalSize += size
        })
        return totalSize
    })
)
